$(document).ready(function() {

  // Get the input element
  const phoneInput = $('#phone');

  // Listen for input event
  phoneInput.on('input', function(event) {
    // Remove any non-digit characters
    const inputValue = event.target.value.replace(/\D/g, '');

    // Format the phone number
    let formattedValue = '';
    for (let i = 0; i < inputValue.length; i++) {
      if (i === 5 || i === 3) {
        formattedValue += ' ' + inputValue[i];
      } else if ((i - 2) % 3 === 0 && i > 2) {
        formattedValue += ' ' + inputValue[i];
      } else {
        formattedValue += inputValue[i];
      }
    }

    $(this).val(formattedValue);
  });
});

function resizeInput() {
  $(this).css('width', this.value.length + 'ch');
}
